export const DATA_MARQUEE_EVENT_LIMIT = 12
export const FOOTER_REPOSITORY_LIMIT = 12
export const SIGN_UP_URL = '/signup'
